import { TGetEnumOptionsDto } from "@/api/services/global/enum/dtos/get-enum-options.dto";
import { TMasterNationality } from "@/api/entities/master-nationality.entity";
import { TMasterCompanySpecificIndustry } from "@/api/entities/master-company-specific-industry.entity";
import { TTag } from "@/api/services/main/tag/dtos/tag.dto";

export type TSharingEntityType = "case" | "talent" | "job";

/** Enum options bundled in the shared verify response so shared (no-auth) pages skip the auth-protected enum API. Keyed by enum name (e.g. "EGender"). */
export type TSharedEnumOptions = Record<string, TGetEnumOptionsDto[]>;

/** Master data bundled in the shared verify response so shared (no-auth) pages skip the auth-protected master/tag APIs. */
export type TSharedMasterData = {
  nationalities?: TMasterNationality[];
  companySpecificIndustries?: TMasterCompanySpecificIndustry[];
  jobTags?: TTag[];
  caseMatchTags?: TTag[];
};

/** Share type: 0 = full info, 1 = masked (hide sensitive fields) */
export const SHARE_TYPE = {
  FULL: 0,
  MASKED: 1,
} as const;

export type TUpsertSharingReqDto = {
  sharePassword: string | null;
  shareUrl: string | null;
  shareUrlExpiredAt?: string | null;
  shareType?: number | null;
};

export type TUpsertSharingResDto = {
  id: number;
  shareUrl: string | null;
  sharePassword: string | null;
  shareUrlExpiredAt?: string | null;
  shareType?: number | null;
};

export type TVerifySharingReqDto = {
  shareUrl: string;
  sharePassword: string;
};

export type TVerifySharingResDto = {
  data: {
    entityType: TSharingEntityType;
    shareType?: number | null;
    data: Record<string, unknown>;
    enumOptions?: TSharedEnumOptions;
    masterData?: TSharedMasterData;
  };
};

export type TGetSharingResDto = {
  id: number;
  shareUrl: string | null;
  sharePassword: string | null;
  shareUrlExpiredAt?: string | null;
  shareType?: number | null;
};

export type TGetSharingDetailDto = {
  matchName: string;
  entityType?: TSharingEntityType;
};

export type TGetSharingDetailResDto = {
  data: TGetSharingDetailDto;
};
